<div class="container mx-auto p-8">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4 class="!text-[24px] !font-semibold !text-[#203D54]">Contracts</h4>
    <!-- Contracts Section -->
    <div class="section-color p-6 mb-8">
      <h2 class="text-xl section-title">Contracts</h2>
      <div class="mb-4">
        <label for="contractTitle" class="block section-label-sm">Title</label>
        <input
          type="text"
          id="contractTitle"
          formControlName="contractTitle"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Title"
        />
        <div
          *ngIf="
            form.get('contractTitle')?.touched &&
            form.get('contractTitle')?.invalid
          "
        >
          <span
            *ngIf="form.get('contractTitle')?.errors?.['required']"
            class="text-red-500 text-sm"
          >
            Title is required
          </span>
        </div>
      </div>
      <div class="mb-4">
        <label for="contractDescription" class="block section-label-sm"
          >Description</label
        >
        <textarea
          id="contractDescription"
          formControlName="contractDescription"
          rows="6"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Description"
        ></textarea>
      </div>
      <div class="mb-4">
        <label for="contractFile" class="block section-label-sm"
          >Attachment</label
        >
        <div class="flex items-center">
          <!-- Plus button for file upload -->
          <button
            type="button"
            (click)="fileInput.click()"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center mr-2"
          >
            +
          </button>
          <input
            type="file"
            id="contractFile"
            #fileInput
            (change)="onFileUpload($event)"
            class="hidden"
            multiple
          />
        </div>

        <!-- File preview section -->
        <div class="mt-4 flex space-x-4">
          <div
            *ngFor="let file of uploadedFiles; let i = index"
            class="relative w-24 h-24 border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Preview Image -->
            <img
              [src]="file.preview"
              alt="File Preview"
              class="object-cover w-full h-full"
            />

            <!-- Cross Icon -->
            <button
              type="button"
              (click)="removeFile(i)"
              class="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
              title="Remove File"
              style="
                height: 25px;
                width: 25px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              ✕
            </button>
          </div>
        </div>
        <div *ngIf="showFileError" class="text-red-500 text-sm mt-2">
          File is required.
        </div>
      </div>
    </div>

    <!-- Summary Section -->
    <div class="section-color p-6 mb-8">
      <h2 class="text-xl section-title mb-4">Summary</h2>
      <div class="mb-4">
        <label for="summary" class="block section-label-sm">Summary</label>
        <textarea
          id="summary"
          formControlName="summary"
          rows="6"
          class="mt-1 p-2 block w-full section-input sm:text-sm"
          placeholder="Enter Summary"
        ></textarea>
      </div>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end">
      <button
        type="button"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center mr-[12px]"
      >
        Back
      </button>
      <button
        type="submit"
        class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center"
      >
        Save
      </button>
    </div>
  </form>
</div>
